
// @ts-nocheck


export const localeCodes =  [
  "en",
  "de",
  "es",
  "fr"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_c452bedd",
      load: () => import("#nuxt-i18n/c452bedd" /* webpackChunkName: "locale_en_46json_c452bedd" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_26310336",
      load: () => import("#nuxt-i18n/26310336" /* webpackChunkName: "locale_de_46json_26310336" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_02c8c7f1",
      load: () => import("#nuxt-i18n/02c8c7f1" /* webpackChunkName: "locale_es_46json_02c8c7f1" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_2dcb0fec",
      load: () => import("#nuxt-i18n/2dcb0fec" /* webpackChunkName: "locale_fr_46json_2dcb0fec" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      dir: "ltr",
      files: [
        {
          path: "/codebuild/output/src1865160114/src/actions-runner/builds/UlLxillN8/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      language: "de-DE",
      dir: "ltr",
      files: [
        {
          path: "/codebuild/output/src1865160114/src/actions-runner/builds/UlLxillN8/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      language: "es-ES",
      dir: "ltr",
      files: [
        {
          path: "/codebuild/output/src1865160114/src/actions-runner/builds/UlLxillN8/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      language: "fr-FR",
      dir: "ltr",
      files: [
        {
          path: "/codebuild/output/src1865160114/src/actions-runner/builds/UlLxillN8/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/fr.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "src/shared/locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: true,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_language",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    dir: "ltr",
    files: [
      {
        path: "/codebuild/output/src1865160114/src/actions-runner/builds/UlLxillN8/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    language: "de-DE",
    dir: "ltr",
    files: [
      {
        path: "/codebuild/output/src1865160114/src/actions-runner/builds/UlLxillN8/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    language: "es-ES",
    dir: "ltr",
    files: [
      {
        path: "/codebuild/output/src1865160114/src/actions-runner/builds/UlLxillN8/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    language: "fr-FR",
    dir: "ltr",
    files: [
      {
        path: "/codebuild/output/src1865160114/src/actions-runner/builds/UlLxillN8/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/fr.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/